import styled from 'styled-components';
import { lowHeightScreens, mediumScreens, smallScreens } from 'components/common/fontElements';
import * as colors from 'components/common/colorConstants';

const Container = styled.div`
  text-align: left;
  word-wrap: break-word;
  overflow-wrap: break-word;
  padding: 0px 25px 150px;
  height: 100%;
  overflow: scroll;
`;

const SubText = styled.p`
  padding: 0px 30px;
  font-family: 'Lato';
  margin-bottom: 0px !important;
  text-align: center;
  font-size: 14px;
  color: ${colors.black1};
  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${mediumScreens}) {
    font-size: 12px;
  }
`;

const SubTextLink = styled(SubText)`
  margin-top: 20px;
  text-decoration: underline;
  cursor: pointer;
`;

const ContentWrapper = styled.div`
  padding: 0px 10px;
`;

const SubMessage = styled.p`
  margin-top: 30px;
`;

const TitleText = styled.p`
  font-family: Lato;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: 0px;
  text-align: center;
  color: ${colors.black1};
  margin: 0px;
  @media screen and (max-width: ${mediumScreens}) {
    font-size: 13px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 12px;
  }
`;

const PageHeader = styled.div`
  padding: 30px 0px 20px;
  border-bottom: 1px solid ${colors.lightWhite2};
  text-align: center;
`;

const Icon = styled.img`
  padding-bottom: 20px;
`;

const MacroHeader = styled.div`
  padding: 20px 0px 20px;
`;

const MacroContent = styled.div`
  white-space: pre-wrap;
  position: relative;
  color: ${colors.baseText};
  font-family: 'Lato-Light', sans-serif;
  font-weight: 300;
  line-height: normal;
  margin: 0px;
  border-top: 1px solid ${colors.lightWhite2};
  border-bottom: 1px solid ${colors.lightWhite2};
  padding: 20px 0px;
`;

const PreformattedText = styled.span`
  white-space: pre-wrap;
`;

const LoadingWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

const BlockingAlert = styled(SubText)`
  padding: 20px 20px 0px 0px;
  margin: 0px;
  text-align: left;
`;

export {
  BlockingAlert,
  LoadingWrapper,
  PreformattedText,
  MacroContent,
  MacroHeader,
  Icon,
  PageHeader,
  TitleText,
  SubMessage,
  ContentWrapper,
  SubTextLink,
  SubText,
  Container,
};
